import styled from "styled-components";

export const MainContainer = styled.div`
    height: 100%;
    padding: 20px 10px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    overflow-y:auto;
`;